import { render, staticRenderFns } from "./Phixsoul.vue?vue&type=template&id=04617cb6&scoped=true&"
import script from "./Phixsoul.vue?vue&type=script&lang=js&"
export * from "./Phixsoul.vue?vue&type=script&lang=js&"
import style0 from "./Phixsoul.vue?vue&type=style&index=0&id=04617cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04617cb6",
  null
  
)

export default component.exports